import gql from "graphql-tag";

export const UPDATE_APPOINTMENT_SESSION = gql`
  mutation UpdateAppointmentSession(
    $UpdateAppointmentSessionInput: UpdateAppointmentSessionInput
  ) {
    updateAppointmentSession(
      updateAppointmentSessionInput: $UpdateAppointmentSessionInput
    ) {
      sessionId
      appointmentToken
    }
  }
`;

export const ADD_TO_CONSULT_QUEUE = gql`
  mutation AddToConsultQueue($appointmentId: String!) {
    addToConsultQueue(appointmentId: $appointmentId) {
      id
      doctorId
    }
  }
`;

export const GET_APPOINTMENT_DATA = gql`
  query GetAppointmentData($appointmentId: String!) {
    getAppointmentData(appointmentId: $appointmentId) {
      appointmentsHistory {
        actualAmount
        discountedAmount
        appointmentType
        id
        patientId
        appointmentDateTime
        status
        paymentStatus
        hospitalId
        doctorId
        isFollowUp
        displayId
        rescheduleCount
        appointmentState
        isJdQuestionsComplete
        isAutomatedQuestionsComplete
        isSeniorConsultStarted
        isConsultStarted
        symptoms
        amountBreakup {
          actual_price
          slashed_price
          cashBack
          final_paid_amount
          bookingFee
          circleCashbackEarned
          circleCouponDiscount
          circlePlanDiscountOnCartItems
        }
        caseSheet {
          prescriptionGeneratedDate
          followUpAfterInDays
          doctorType
          diagnosticPrescription {
            itemname
          }
          medicinePrescription {
            medicineName
          }
          sentToPatient
        }
        appointmentMetaData {
          appointmentProjectType
        }
        patientInfo {
          id
          gender
          dateOfBirth
          uhid
          firstName
          lastName
          relation
          mobileNumber
        }
        chatId
        doctorInfo {
          mobileNumber
          id
          salutation
          firstName
          lastName
          displayName
          fullName
          experience
          onlineConsultationFees
          physicalConsultationFees
          consultHours {
            consultMode
          }
          specialty {
            name
            id
          }
          qualification
          city
          photoUrl
          thumbnailUrl
          doctorType
          doctorHospital {
            facility {
              id
              name
              streetLine1
              streetLine2
              streetLine3
              city
              latitude
              longitude
            }
            isPrimary
          }
        }
      }
    }
  }
`;

export const VALIDATE_CONSULT_COUPON = gql`
  query ValidateConsultCoupon(
    $doctorId: ID!
    $code: String!
    $consultType: AppointmentType!
    $appointmentDateTimeInUTC: DateTime!
  ) {
    validateConsultCoupon(
      doctorId: $doctorId
      code: $code
      consultType: $consultType
      appointmentDateTimeInUTC: $appointmentDateTimeInUTC
    ) {
      validityStatus
      revisedAmount
      reasonForInvalidStatus
    }
  }
`;

export const MAKE_APPOINTMENT_PAYMENT = gql`
  mutation makeAppointmentPayment($paymentInput: AppointmentPaymentInput) {
    makeAppointmentPayment(paymentInput: $paymentInput) {
      appointment {
        id
        amountPaid
        paymentRefId
        paymentDateTime
        responseCode
        responseMessage
        bankTxnId
        orderId
        appointment {
          id
        }
      }
    }
  }
`;

export const CONSULT_COUPONS_LIST = gql`
  query getConsultCouponList {
    getConsultCouponList {
      coupons {
        code
        displayStatus
        couponConsultRule {
          isActive
        }
        createdDate
        description
        id
        isActive
      }
    }
  }
`;

export const GET_CONSULT_PAYMENTS = gql`
  query ConsultOrders($patientId: String, $pageNo: Int!, $pageSize: Int!) {
    consultOrders(patientId: $patientId, pageNo: $pageNo, pageSize: $pageSize) {
      appointments {
        displayId
        id
        appointmentDateTime
        actualAmount
        discountedAmount
        appointmentType
        appointmentPayments {
          amountPaid
          bankTxnId
          id
          paymentRefId
          paymentStatus
          paymentType
          responseMessage
          paymentDateTime
        }
        PaymentOrders {
          amountPaid
          paymentDateTime
          paymentRefId
          paymentStatus
        }
        status
        doctorId
        doctor {
          typeId
          name
        }
      }
    }
  }
`;

export const GET_CONSULT_INVOICE = gql`
  query GetOrderInvoice(
    $patientId: String!
    $appointmentId: String!
    $emailId: Email
  ) {
    getOrderInvoice(
      patientId: $patientId
      appointmentId: $appointmentId
      emailId: $emailId
    )
  }
`;

export const UPLOAD_MEDIA_DOCUMENT_PRISM = gql`
  mutation uploadMediaDocument(
    $MediaPrescriptionUploadRequest: MediaPrescriptionUploadRequest
    $uhid: String!
    $appointmentId: ID!
  ) {
    uploadMediaDocument(
      prescriptionInput: $MediaPrescriptionUploadRequest
      uhid: $uhid
      appointmentId: $appointmentId
    ) {
      recordId
      fileUrl
    }
  }
`;

export const ADD_CHAT_DOCUMENTS = gql`
  mutation addChatDocument(
    $appointmentId: ID!
    $documentPath: String
    $prismFileId: String
  ) {
    addChatDocument(
      appointmentId: $appointmentId
      documentPath: $documentPath
      prismFileId: $prismFileId
    ) {
      id
      documentPath
      prismFileId
    }
  }
`;

export const JOIN_JDQ_WITH_AUTOMATED_QUESTIONS = gql`
  mutation AddToConsultQueueWithAutomatedQuestions(
    $ConsultQueueInput: ConsultQueueInput
  ) {
    addToConsultQueueWithAutomatedQuestions(
      consultQueueInput: $ConsultQueueInput
    ) {
      id
      doctorId
      totalJuniorDoctorsOnline
      juniorDoctorsList {
        juniorDoctorId
        doctorName
        # queueCount
      }
      totalJuniorDoctors
      isJdAllowed
    }
  }
`;

export const GET_CASESHEET_DETAILS = gql`
  query caseSheet($appointmentId: String) {
    caseSheet(appointmentId: $appointmentId) {
      caseSheetDetails {
        appointment {
          id
          appointmentDateTime
          appointmentState
          appointmentType
          doctorId
          hospitalId
          patientId
          parentId
          status
          displayId
          isFollowUp
          patientLocation {
            city
            pincode
          }
          doctorInfo {
            id
            fullName
            gender
            photoUrl
            displayName
            mobileNumber
            specialty {
              id
              name
            }
            doctorHospital {
              facility {
                id
                name
                city
              }
            }
          }
        }
        consultType
        diagnosis {
          name
        }
        diagnosticPrescription {
          itemname
          testInstruction
        }
        radiologyPrescription {
          servicename
          serviceid
          testInstruction
        }
        blobName
        doctorId
        followUp
        followUpAfterInDays
        followUpDate
        followUpConsultType
        doctorType
        id
        prescriptionGeneratedDate
        medicinePrescription {
          id
          externalId
          medicineName
          medicineDosage
          medicineToBeTaken
          medicineInstructions
          medicineTimings
          medicineUnit
          medicineConsumptionDurationInDays
          medicineConsumptionDuration
          medicineFormTypes
          medicineFrequency
          medicineConsumptionDurationUnit
          routeOfAdministration
          medicineCustomDosage
          medicineCustomDetails
          includeGenericNameInPrescription
          genericName
        }
        notes
        otherInstructions {
          instruction
        }
        patientId
        symptoms {
          symptom
          since
          howOften
          severity
        }
        referralSpecialtyName
        referralDescription
        followupConsultationDetails {
          days
          appointmentType
          instructions
        }
        prescriptionDocumentInfo {
          documentId
          hashedDocumentId
        }
        patientDetails {
          id
          patientAddress {
            id
            zipcode
            state
            city
            defaultAddress
          }
          relation
        }
      }
      patientDetails {
        id
      }
    }
  }
`;

export const PAST_APPOINTMENTS_COUNT = gql`
  query GetPastAppointmentsCount(
    $doctorId: String!
    $patientId: String!
    $appointmentId: String!
  ) {
    getPastAppointmentsCount(
      doctorId: $doctorId
      patientId: $patientId
      appointmentId: $appointmentId
    ) {
      count
      completedCount
      yesCount
      noCount
    }
  }
`;

export const UPDATE_SAVE_EXTERNAL_CONNECT = gql`
  mutation UpdateSaveExternalConnect(
    $doctorId: String!
    $patientId: String!
    $externalConnect: Boolean
    $appointmentId: String!
  ) {
    updateSaveExternalConnect(
      doctorId: $doctorId
      patientId: $patientId
      externalConnect: $externalConnect
      appointmentId: $appointmentId
    ) {
      status
    }
  }
`;

export const BOOK_FOLLOWUP_APPOINTMENT = gql`
  mutation BookFollowUpAppointment(
    $followUpAppointmentInput: BookFollowUpAppointmentInput!
  ) {
    bookFollowUpAppointment(
      followUpAppointmentInput: $followUpAppointmentInput
    ) {
      appointment {
        id
        isFollowUp
        doctorId
        appointmentType
        appointmentState
        appointmentDateTime
        patientId
        status
      }
    }
  }
`;

export const GET_APPOINTMENT_DOCTOR_RESCHEDULED_DETAILS = gql`
  query getAppointmentRescheduleDetails($appointmentId: String!) {
    getAppointmentRescheduleDetails(appointmentId: $appointmentId) {
      id
      rescheduleReason
      rescheduledDateTime
      rescheduleInitiatedBy
      rescheduleInitiatedId
      rescheduleStatus
    }
  }
`;

export const INSERT_MESSAGE_POST_CONSULT = gql`
  mutation InsertMessage($messageInput: MessageInput) {
    insertMessage(messageInput: $messageInput) {
      notificationData {
        fromId
        toId
        eventName
        eventId
        message
        status
        type
        id
      }
    }
  }
`;

export const GET_PROFILE_CONSULT_COUNT = gql`
  query GetProfileConsultCount {
    getProfileConsultCount {
      patientid
      count
    }
  }
`;

export const CREATE_CALENDAR_EVENT = gql`
  mutation createMsTeamCalendarEvent(
    $msTeamCalendarEventInput: MsTeamCalendarEventInput
  ) {
    createMsTeamCalendarEvent(
      msTeamCalendarEventInput: $msTeamCalendarEventInput
    ) {
      requestType
      entry {
        creatorTenantId
        creatorAADId
        summary
        description {
          content
          contentType
        }
        startDateTime
        endDateTime
        location {
          displayName
        }
        attendees
        isOnlineMeeting
      }
    }
  }
`;

export const UPDATE_APPOINTMENT = gql`
  mutation updateAppointment($appointmentInput: UpdateAppointmentInput) {
    updateAppointment(appointmentInput: $appointmentInput) {
      error
      status
    }
  }
`;

export const BOOK_APPOINTMENT_RESCHEDULE = gql`
  mutation bookRescheduleAppointment(
    $bookRescheduleAppointmentInput: BookRescheduleAppointmentInput!
  ) {
    bookRescheduleAppointment(
      bookRescheduleAppointmentInput: $bookRescheduleAppointmentInput
    ) {
      appointmentDetails {
        appointmentType
        id
        doctorId
        appointmentState
        appointmentDateTime
        status
        patientId
        rescheduleCount
      }
    }
  }
`;

export const GET_PATIENT_ALL_APPOINTMENTS = gql`
  query GetPatientAllAppointments(
    $patientId: String
    $patientMobile: String
    $offset: Int
    $limit: Int
  ) {
    getPatientAllAppointments(
      patientId: $patientId
      patientMobile: $patientMobile
      offset: $offset
      limit: $limit
    ) {
      totalAppointmentCount
      appointments {
        id
        patientId
        patientName
        doctorId
        appointmentDateTime
        appointmentType
        hospitalId
        status
        bookingDate
        rescheduleCount
        isFollowUp
        appointmentState
        displayId
        isConsultStarted
        isSeniorConsultStarted
        isJdQuestionsComplete
        isAutomatedQuestionsComplete
        prescriptionReason
        caseSheet {
          followUpAfterInDays
          doctorType
          sentToPatient
          diagnosticPrescription {
            itemname
          }
          medicinePrescription {
            medicineName
          }
          isJdConsultStarted
        }
        doctorInfo {
          city
          displayName
          doctorType
          experience
          firstName
          fullName
          gender
          id
          lastName
          mobileNumber
          onlineConsultationFees
          photoUrl
          physicalConsultationFees
          salutation
          allowBookingRequest
          allowBookingRequestForOnline
          languages
          doctorHospital {
            facility {
              city
              country
              facilityType
              id
              imageUrl
              latitude
              longitude
              name
              state
              streetLine1
              streetLine2
              streetLine3
              zipcode
            }
          }
          consultHours {
            consultMode
            consultType
            endTime
            id
            isActive
            startTime
            weekDay
            actualDay
          }
          specialty {
            id
            name
            specialistSingularTerm
            specialistPluralTerm
            image
          }
          consultHours {
            consultMode
            consultType
            endTime
            id
            isActive
            startTime
            weekDay
            consultDuration
            consultBuffer
            actualDay
          }
          doctorPricing {
            slashed_price
            available_to
            mrp
            appointment_type
            status
            group_plan
            is_cashback_enabled
            cashback_amount
          }
        }
      }
    }
  }
`;

export const APPOINTMENT_BOOKING_REQUEST = gql`
  mutation appointmentBookingRequest(
    $bookAppointment: AppointmentBookingRequestInput!
  ) {
    appointmentBookingRequest(appointmentInput: $bookAppointment) {
      appointment {
        id
        doctorId
        appointmentDateTime
        status
        appointmentType
        patientId
        __typename
      }
      __typename
    }
  }
`;

export const CASESHEET_DETAILS_QUERY = gql`
  query caseSheet($appointmentId: String) {
    caseSheet(appointmentId: $appointmentId) {
      caseSheetDetails {
        appointment {
          id
          appointmentDateTime
          appointmentState
          appointmentType
          doctorId
          hospitalId
          patientId
          parentId
          status
          displayId
          isFollowUp
          patientLocation {
            city
            pincode
          }
          doctorInfo {
            id
            fullName
            gender
            photoUrl
            displayName
            mobileNumber
            emailAddress
            qualification
            registrationNumber
            specialty {
              id
              name
            }
            doctorHospital {
              facility {
                id
                name
                city
                helpLineNumber
                state
                streetLine1
                streetLine2
                streetLine3
                zipcode
              }
            }
          }
        }
        patientDetails {
          patientAddress {
            latitude
            longitude
            zipcode
          }
        }
        consultType
        diagnosis {
          name
        }
        diagnosticPrescription {
          itemname
          testInstruction
        }
        prescriptionDocumentInfo {
          documentId
          hashedDocumentId
        }
        radiologyPrescription {
          servicename
          serviceid
          testInstruction
        }
        blobName
        doctorId
        followUp
        followUpAfterInDays
        followUpDate
        followUpConsultType
        doctorType
        id
        prescriptionGeneratedDate
        medicinePrescription {
          id
          externalId
          medicineName
          medicineDosage
          medicineToBeTaken
          medicineInstructions
          medicineTimings
          medicineUnit
          medicineConsumptionDurationInDays
          medicineConsumptionDuration
          medicineFormTypes
          medicineFrequency
          medicineConsumptionDurationUnit
          routeOfAdministration
          medicineCustomDosage
          medicineCustomDetails
          includeGenericNameInPrescription
          genericName
        }
        notes
        otherInstructions {
          instruction
        }
        patientId
        symptoms {
          symptom
          since
          howOften
          severity
          details
        }
        referralSpecialtyName
        referralDescription
        followupConsultationDetails {
          days
          appointmentType
          instructions
        }
        substitutionEnabled
      }
      deepLinks {
        diagnosticCartRedirectionDeeplink
        doctorProfileDeepLink
        medicineCartRedirectionDeeplink
      }
      patientDetails {
        id
        firstName
        gender
        lastName
        dateOfBirth
        mobileNumber
        uhid
        patientMedicalHistory {
          bp
          height
          weight
          temperature
          drugAllergies
          dietAllergies
        }
        patientAddress {
          id
          zipcode
          state
          city
        }
      }
    }
  }
`;
export const SAVE_SYMPTOM_CHECKER_INFO = gql`
  mutation savePatientAskApolloInfo(
    $patientAskApolloInfo: PatientAskApolloInfoInput
  ) {
    savePatientAskApolloInfo(patientAskApolloInfo: $patientAskApolloInfo) {
      id
      chatId
      patientId
      mobileNumber
    }
  }
`;
